<p *ngIf="response">
  <a target="_blank" href="{{response?.pdf}}">View Statement  <span *ngIf="response?.password!=''">Password = {{response.password}}</span></a>
</p>
